import { BrowserRouter as Router } from "react-router-dom";
import RoutesApp from "./routes";

export default function App() {
  return (
    <Router>
      <RoutesApp />
    </Router>
  );
}
